<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6><h6>{{ $t("auth.Profile") }}</h6></h6>
          <p class="font13 gray-col">{{ $t("auth.chanephone") }}</p>
        </div>
      </div>
      <div class="card-details-def pad-big">
        <div class="col-md-7 col-12">
          <v-form @submit.prevent="changePhoneValid" v-model="valid" ref="form">
            <div class="main-input-cont mt-1 tel-input-me">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.phone') }}</h6>
              <v-text-field
                v-model="phone"
                type="number"
                min="0"
                name="phone"
                :rules="phoneRules"
                :placeholder="$t('auth.phoneplace')"
              ></v-text-field>
              <div class="drop-countries top-def">
                <Dropdown
                  v-model="selectedCountry"
                  :options="countries"
                  optionLabel="name"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex-group-me">
                      <img
                        :alt="slotProps.value.label"
                        :src="slotProps.value.image"
                        :class="`mr-2 flag flag-${slotProps.value.key.toLowerCase()}`"
                        style="width: 24px"
                      />
                      <div>{{ slotProps.value.key }}</div>
                    </div>
                    <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                  </template>
                  <template #option="slotProps">
                    <div class="flex-group-me">
                      <img
                        :alt="slotProps.option.label"
                        :src="slotProps.option.image"
                        :class="`mr-2 flag flag-${slotProps.option.key.toLowerCase()}`"
                        style="width: 24px"
                      />
                      <div>{{ slotProps.option.key }}</div>
                    </div>
                  </template>
                </Dropdown>
              </div>
            </div>
            <div class="flex-sm-gap mb-3">
              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up w-100 mt-3 xl"
              >
                <div v-if="!disabled">{{ $t("auth.confirm") }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('auth.confirming') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import { ref, onMounted } from "vue";
// import ChangePassword from "./changePassword.vue";
import axios from "axios";
import Dropdown from "primevue/dropdown";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();
import i18n from "@/i18n";

// reactive state

const valid = ref(false);
const disabled = ref(false);
const form = ref(null);
const phone = ref("");
const selectedCountry = ref({
  key: "+966",
  code: "SA",
  image:
    "https://backend.saqf-sa.com/storage/images/countries/1704282290_8447.png",
});
const countries = ref([]);

const phoneRules = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.phoneValid`);
  },
  (value) => {
    if (value.length >= 9) return true;

    return i18n.global.t(`auth.phoneValidnumber`);
  },
]);

// functions

function changePhoneValid() {
  if (valid.value) {
    changePhone();
  }
}
function getCountries() {
  axios.get("/countries").then((response) => {
    countries.value = response.data.data;
  });
}

function changePhone() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  fd.append("country_code", selectedCountry.value.key);
  fd.append("password", localStorage.getItem("password"));

  axios
    .post("/manager/change-phone-send-code", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
        localStorage.setItem("phone", phone.value);
        localStorage.setItem("country_code", selectedCountry.value.key);
        localStorage.setItem("countryImgTest", selectedCountry.value.image);

        router.push("/phoneCheckOtp");
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
// lifecycle hooks
onMounted(() => {
  getCountries();
});
</script>
